import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import './Signup.css'
import { LogoLogin } from '../../assets/imgs'
import { InputText, Btn, TextBtn } from '../../components'
import { hideLoadingBox, showLoadingBox, showMessageBox } from '../../store/actions/system.actions'
import useSignup, { LOAD_MESSAGE } from './SignupHook'

function Signup({ dispatch, history }) {
  const { state, localDispatch } = useSignup()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.REGISTERING:
        localDispatch.requestUserRegister(state.formFields)
        dispatch(showLoadingBox(LOAD_MESSAGE.REGISTERING, 'Aguarde...'))
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox('Cadastro efetuado', null))
        localDispatch.resetState()
        history.goBack()
        break
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div className="Signup">
      <div className="Signup__container">
        <header>
          <img src={LogoLogin} alt="Logo - CoLog" />
        </header>
        <div className="p-grid ">
          <div className="p-md-6 p-col-12">
            <InputText
              label="Nome :"
              type="text"
              value={state.formFields.name}
              onChange={content => localDispatch.onInputChange('name', content)}
            />
          </div>
          <div className="p-md-6 p-col-12">
            <InputText
              label="E-mail :"
              type="email"
              value={state.formFields.email}
              onChange={content => localDispatch.onInputChange('email', content)}
            />
          </div>
          <div className="p-md-6 p-col-12">
            <InputText
              marginTop="10"
              label="Senha :"
              type="password"
              value={state.formFields.password}
              onChange={content => localDispatch.onInputChange('password', content)}
            />
          </div>
          <div className="p-md-6 p-col-12">
            <InputText
              marginTop="10"
              label="Confirme a Senha :"
              type="password"
              value={state.formFields.confirmedPassword}
              onChange={content => localDispatch.onInputChange('confirmedPassword', content)}
              onEnter={localDispatch.onSalvarClicked}
            />
          </div>

          <div className="p-md-6 p-col-12 text-center text-md-left">
            <TextBtn onClick={() => history.goBack()}>Voltar para Tela de Login</TextBtn>
          </div>
          <div className="p-md-6 p-col-12 text-center text-md-right">
            <Btn onClick={localDispatch.onSalvarClicked}>Salvar</Btn>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect()(Signup)
